import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './BellaKiosk.css';

function BellaKiosk({ user }) {
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || user.role !== 'admin') {
      navigate('/dashboard');
    }
  }, [user, navigate]);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
    script.async = true;
    script.type = 'text/javascript';
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <div className="bella-kiosk-container">
      <div className="bella-kiosk-header">
        <button onClick={() => navigate('/dashboard')} className="back-button">
          ← Back to Dashboard
        </button>
        <h1>Bella Kiosk Demo</h1>
      </div>
      
      <div className="bella-widget-container">
        <div className="bella-widget-wrapper">
          <img src="/images/hands_together.png" alt="Hands Together" className="bella-background-image" />
          <elevenlabs-convai agent-id="O9VI1OoHqaHpzvV0mftN"></elevenlabs-convai>
        </div>
      </div>
    </div>
  );
}

export default BellaKiosk;